import { Box, Container, Typography } from '@mui/material';

function About() {
  return (
    <Container maxWidth="md">
      <Box sx={{ pb: 3 }}>
        <Typography variant="h5" color="inherit">
          About
        </Typography>
      </Box>

      <Box sx={{ pb: 3 }}>
        <Typography color="inherit">
          The Cutting Board Designer is a free tool for designing cutting
          boards. This is not the first cutting board designer to be made, but
          it is unique in that it supports multiple methods of building cutting
          boards. Most designers support just one method of building a board. I
          call this method the "Strips" method. You can get some pretty neat
          patterns out of this method, but there are so many other interesting
          methods that make so many interesting patterns. I've added support for
          some of the more interesting and reusable methods of building a board.
          Some of them I've tried with varying degrees of success, and others I
          just think are cool and would like to try some day.
        </Typography>
      </Box>

      <Box sx={{ pb: 3 }}>
        <Typography color="error">
          The Cutting Board Designer does not support IE because I'm not at work
          and I don't have to{' '}
          <span aria-label="Smiley" role="img">
            😃
          </span>
        </Typography>
      </Box>

      <Box sx={{ pb: 3 }}>
        <Typography variant="h5" color="inherit">
          Origin
        </Typography>
      </Box>

      <Box sx={{ pb: 3 }}>
        <Typography color="inherit">
          I built this tool because I found that drawing designs on paper was
          slow and tedious and I couldn't justify investing in CAD software for
          something this simple. As a completely novice woodworker, I decided an
          end grain cutting board would be a good project to try. My first
          attempt went ok, and I became fascinated with all of the pattern
          possibilities that I could build. Once I had built more cutting boards
          than I'd ever need, I decided to offer to build them for friends and
          family as long as they paid for the materials. At that point, I had a
          half baked version of this tool that I was just using for myself, but
          I thought it would be great if I could send it to friends and family
          to have them design a board that they liked and that fit their budget.
          So I kept hacking away at it until it was in it's current form in
          front of you right now.
        </Typography>
      </Box>
    </Container>
  );
}

export default About;
